import { Component, OnInit, Input, HostBinding, Output, EventEmitter, ContentChild, TemplateRef, ViewEncapsulation, SimpleChanges, OnChanges, ChangeDetectorRef, ViewChildren, ElementRef, ViewChild, Optional, inject, Injector } from '@angular/core';
import { FUploadFileExtend } from '../../model/index';
import { FFilePreviewListTypeTemplateDirective, FFilePreviewToolbarTemplateDirective } from '../../directive/index';
import { FFileUtils } from '../../utils';
import { LocaleService } from '@farris/ui-locale';

@Component({
    selector: 'f-file-preview',
    templateUrl: './f-file-preview.component.html',
    styleUrls: ['./f-file-preview.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class FFilePreviewComponent implements OnInit, OnChanges {
    @HostBinding('class.ffilepreview--wrapper') cls = true;
    @HostBinding('class.ffilepreview-unvisible') get visibleState() {
        return !this.visible;
    }
    // 只读的状态，控制附件是否可删除
    @Input() readonly = true;
    private _defaultItemCls = '';
    @Input()
    set defaultItemCls(value: string) {
        this._defaultItemCls = value;
    }
    get defaultItemCls(): string {
        //如果有自定义的值
        if (this._defaultItemCls) {
            return this._defaultItemCls + ' ';
        }
        // 如果有自定义模板
        if (this.listTypeTemplate) {
            return 'ffilepreview--item ';
        }
        return this.type == 'list' ? 'ffilepreview--item ' : 'ffilepreview--item col-sm-12 col-md-6 col-xl-3 col-el-2 ';
    }
    @Input() visible = true;
    // 是否启用批量操作
    @Input() enableMulti = false;
    // list类型 card类型
    @Input() type = "list";
    // 列项上的class
    @Input() itemCls = "";
    // Header的class
    @Input() headerCls = '';
    // 启用重命名
    @Input() canRename = false;
    // 默认重命名
    @Input() defaultRename = '';
    // 
    @Input() enableCardAreaResponse = true;
    // 标记是否显示重命名输入框
    showRenameInput = false;
    @ViewChild('multiRenameInput') multiRenameRef: ElementRef;
    //@Input() fileInfos:FUploadFileExtend[]=[];
    private _fileInfos: FUploadFileExtend[] = [];
    @Input()
    set fileInfos(val: FUploadFileExtend[]) {
        this._fileInfos = this.formatDatas(val);;
    }
    get fileInfos(): FUploadFileExtend[] {
        return this._fileInfos;
    };
    // 附件预览信息，抛出对象给第三方处理
    @Output() filePreviewEvent = new EventEmitter<FUploadFileExtend>();
    // 附件下载事件，抛出对象给第三方处理
    @Output() fileDownloadEvent = new EventEmitter<{ fileInfos: FUploadFileExtend[], name: string }>();
    @Output() multiSelectedEvent = new EventEmitter<FUploadFileExtend[]>();
    // 附件删除事件，抛出对象给第三方处理
    @Output() fileRemoveEvent = new EventEmitter<FUploadFileExtend>();
    @ContentChild(FFilePreviewListTypeTemplateDirective, { read: TemplateRef }) listTypeTemplate: TemplateRef<any>;
    @ContentChild(FFilePreviewToolbarTemplateDirective, { read: TemplateRef }) toolbarTemplate: TemplateRef<any>;
    multiSelected: FUploadFileExtend[] = [];
    // 全选状态
    selectAllBtnChecked = false;
    settings = {
        readonly: this.readonly,
        visible: this.visible,
        enableMulti: this.enableMulti
    };
    /**2023年12月23日，标记
     * 预览组件，没有多语言服务相关的，
     * 如果只有预览组件，重新生成、编译，也会获取多语言服务。
     */
    private hasLocalSer=false;
    constructor(private cd: ChangeDetectorRef,@Optional() private inject:Injector) {
         // 看是否多语言服务已更新
         this.hasLocalSer=FFileUtils.getLocalState(null);
         // 为多语言服务赋值
         if(this.inject&&!this.hasLocalSer){
            this.hasLocalSer=FFileUtils.getLocalState(this.inject.get(LocaleService));
         }
    }
    ngOnInit() {

    }
    ngOnChanges(changes: SimpleChanges) {
        // if (changes['enableMultiDownload']) {
        //     this.formatDatas(this.fileInfos);
        // }
    }
    /**
     * 格式化数据
     * @param val 
     */
    formatDatas(val) {
        if (this.enableMulti) {
            let formatValue= val.map((item: FUploadFileExtend) => {
                // if (!item.hasOwnProperty('checked')) {
                //     //
                //     let findItem = this._fileInfos.find(olditem => {
                //         return item.id == olditem.id;
                //     });
                //     if (findItem && findItem.hasOwnProperty('checked')) {
                //         item['checked'] = findItem['checked'];
                //     } else {
                //         item['checked'] = this.selectAllBtnChecked;
                //     }
                // }
                item['checked'] = this.selectAllBtnChecked;
                return item;
            });
            // 归集已选数据
            if(this.selectAllBtnChecked){
                this.multiSelected=[...formatValue];
            }else{
                this.multiSelected=[];
            }
            // 返回格式化数据
            return formatValue;
        } else {
            return val;
        }
    }
    /**
     * 预览
     * @param ev 
     * @param fileInfo 
     */
    filePreviewHandler(ev: Event, fileInfo: FUploadFileExtend) {
        ev.stopImmediatePropagation();
        this.filePreviewEvent.emit(fileInfo);
    }
    /**
     * 下载
     * @param ev 
     * @param fileInfo 
     */
    fileDownloadHandler(ev: Event, fileInfo: FUploadFileExtend) {
        ev.stopImmediatePropagation();
        this.fileDownloadEvent.emit({ fileInfos: [fileInfo], name: '' });
    }
    fileMultiDownloadHandler(ev: Event) {
        ev.stopImmediatePropagation();
        let rename = '';
        if (this.showRenameInput) {
            rename = this.multiRenameRef.nativeElement.value;
        }
        if (rename == '') {
            rename = this.defaultRename;
        }
        this.fileDownloadEvent.emit({ fileInfos: this.multiSelected, name: rename });
    }
    /**
     * checkbox多选
     * @param ev 
     */
    multiSelectChange(ev) {
        let hasInArray = this.multiSelected.findIndex(item => item['id'] == ev['id']);
        let findInArray = this.fileInfos.findIndex(item => item['id'] == ev['id']);
        if (findInArray > -1) {
            this.fileInfos[findInArray]['checked'] = ev['checked'];
        }

        if (ev['checked']) {
            //选入
            if (hasInArray == -1) {
                if (findInArray > -1) {
                    this.multiSelected.push(this.fileInfos[findInArray]);
                }
            }
        } else {
            //移出
            if (hasInArray > -1) {
                this.multiSelected.splice(hasInArray, 1);
            }
        }
        // 判断是否全选
        if (this.fileInfos.length > 0) {
            if (this.multiSelected.length == this.fileInfos.length) {
                //都全选
                this.selectAllBtnChecked = true;
            } else {
                // 未全选
                this.selectAllBtnChecked = false;
            }
        }
        // 抛出多选
        this.multiSelectedEvent.emit(this.multiSelected);
    }
    /**
     * 删除数据
     * @param ev 
     * @param fileInfo 
     */
    fileRemoveHandler(ev: Event, fileInfo: FUploadFileExtend) {
        ev.stopImmediatePropagation();
        this.fileRemoveEvent.emit(fileInfo);
    }
    /**
     * 获取文档类型对应的class
     * @param fileName 
     */
    getFileTypeClassName(fileName) {
        let clsName = 'ffilepreview--filetype';
        // 如果名称为空
        if (!fileName) {
            return clsName + '-any';
        }
        let lastDotIndex = fileName.lastIndexOf(".");
        let fileSuffix = '';
        if (lastDotIndex > -1) {
            fileSuffix = fileName.substring(lastDotIndex + 1).toLocaleLowerCase();
        }
        switch (fileSuffix) {
            case 'pdf':
                clsName += '-pdf';
                break;
            case 'jpeg':
            case 'jpg':
            case 'gif':
            case 'svg':
            case 'png':
            case 'bmp':
                clsName += '-img';
                break;
            case 'ppt':
            case 'pptx':
                clsName += '-ppt';
                break;
            case 'doc':
            case 'docx':
                clsName += '-doc';
                break;
            case 'xls':
            case 'xlsx':
                clsName += '-xls';
                break;
            case 'txt':
                clsName += '-txt';
                break;
            case 'zip':
                clsName += '-zip';
                break;
            default:
                clsName += '-any';
        }
        return clsName;
    }
    
    /**
     * 是不是有附件名称
     * @param name 
     */
    hasFileName(name): boolean {
        if (!name) {
            return false;
        }
        return true;
    }
    /**
     * 选择或取消所有
     * @param ev 
     */
    selectOrCancelAllHandler(ev) {
        if (ev['checked']) {
            // 全选
            this.fileInfos.forEach(item => {
                item.checked = true;
            });
            this.multiSelected = [...this.fileInfos];
            this.selectAllBtnChecked = true;

        } else {
            // 取消
            this.multiSelected = [];
            this.fileInfos.forEach(item => {
                item.checked = false;
            });
            this.selectAllBtnChecked = false;
        }
        this.cd.detectChanges();
    }
    /**
     * 显示隐藏输入名称
     */
    toggleRenameInput(ev) {
        ev.stopPropagation();
        this.showRenameInput = !this.showRenameInput;
        if (!this.multiRenameRef.nativeElement.value) {
            this.multiRenameRef.nativeElement.value = this.defaultRename;
        }
    }
}
